import { defineStore } from "pinia";
import { ref } from "vue";

export var timeCalculatorSettings = defineStore('TimeCalculatorStore',() =>
{
    var lightMode = ref(true);
    var timezoneShown = ref(false);

    const changeTheme = () =>
    {
        lightMode.value = !lightMode.value;
    }

    const toggleTimezoneMenu = () =>
    {
        timezoneShown.value = !timezoneShown.value;
    }

    return {
        lightMode,
        timezoneShown,
        changeTheme,
        toggleTimezoneMenu
    }
});